import React from 'react';

import { useTranslation } from 'react-i18next';

import { Form, Select, Input } from '@weezevent/nacre';
import '../webServices.scss';

export function LoginAndPassword({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.login')}</Form.Label>
                <Input value={formState.login} onChange={event => setFormState('login', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['login']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.password')}</Form.Label>
                <Input value={formState.password} type="password" onChange={event => setFormState('password', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['password']) || ['']]} />
        </>
    );
}

export function DigitickForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.digitick_wsdl')}</Form.Label>
                <Select useNew value={formState.wsdl} onChange={(_, { value }) => setFormState('wsdl', value)} options={DigitickForm.options} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['wsdl']) || ['']]} />
            <LoginAndPassword formState={formState} setFormState={setFormState} formErrors={formErrors} />
        </>
    );
}

DigitickForm.options = [
    {
        text: 'Digitick',
        value: 'default'
    },
    {
        text: 'Seeticket',
        value: 'seetickets'
    }
];

export function FeverForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.fever_api_key')}</Form.Label>
                <Input value={formState.api_key} onChange={event => setFormState('api_key', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['api_key']) || ['']]} />
        </>
    );
}

export function TicketmasterSportForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.ticketmastersport_api_key')}</Form.Label>
                <Input value={formState.api_key} onChange={event => setFormState('api_key', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['api_key']) || ['']]} />
        </>
    );
}

export function FnacForm({ formState, setFormState, formErrors }) {
    return <LoginAndPassword formState={formState} setFormState={setFormState} formErrors={formErrors} />;
}

export function UniverseForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.universe_auth_code')}</Form.Label>
                <Input
                    value={formState.authCode}
                    onChange={event => {
                        setFormState('authCode', event.target.value);
                    }}
                />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['authCode']) || ['']]} />
        </>
    );
}

export function LenndForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.lennd_access_token')}</Form.Label>
                <Input
                    value={formState.accessToken}
                    onChange={event => {
                        setFormState('accessToken', event.target.value);
                    }}
                />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['accessToken']) || ['']]} />
        </>
    );
}

export function RegiondoForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.regiondo_public_key')}</Form.Label>
                <Input value={formState.public_key} onChange={event => setFormState('public_key', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['public_key']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.regiondo_private_key')}</Form.Label>
                <Input value={formState.private_key} onChange={event => setFormState('private_key', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['private_key']) || ['']]} />
        </>
    );
}

export function SecutixForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <LoginAndPassword formState={formState} setFormState={setFormState} formErrors={formErrors} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.secutix_url')}</Form.Label>
                <Input value={formState.url} onChange={event => setFormState('url', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['url']) || ['']]} />
        </>
    );
}

export function SeeticketsDEForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.seetickets_de_merchant_id')}</Form.Label>
                <Input value={formState.merchant_id} onChange={event => setFormState('merchant_id', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['merchant_id']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.seetickets_de_refresh_token')}</Form.Label>
                <Input value={formState.refresh_token} onChange={event => setFormState('refresh_token', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['refresh_token']) || ['']]} />
        </>
    );
}

export function SeeticketESForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.seeticket_es_promoter_id')}</Form.Label>
                <Input value={formState.promoter_id} onChange={event => setFormState('promoter_id', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['promoter_id']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.seeticket_es_promoter_name')}</Form.Label>
                <Input value={formState.promoter_name} onChange={event => setFormState('promoter_name', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['promoter_name']) || ['']]} />
        </>
    );
}

export function TicketnetForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.ticketnet_account_type')}</Form.Label>
                <Select useNew value={formState.account_type} onChange={(_, { value }) => setFormState('account_type', value)} options={TicketnetForm.options} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['account_type']) || ['']]} />
            <LoginAndPassword formState={formState} setFormState={setFormState} formErrors={formErrors} />
        </>
    );
}

TicketnetForm.options = [
    {
        text: 'Dist',
        value: 'dist'
    },
    {
        text: 'Prod',
        value: 'prod'
    },
    {
        text: 'Single Prod',
        value: 'single_prod'
    },
    {
        text: 'Stades',
        value: 'stades'
    },
    {
        text: 'Billet Stock',
        value: 'stock'
    },
    {
        text: 'Prod 3',
        value: 'prod3'
    },
    {
        text: 'Palais',
        value: 'palais'
    }
];

export function PlaypassForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.tenant')}</Form.Label>
                <Input value={formState.tenant} onChange={event => setFormState('tenant', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['tenant']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.access_id')}</Form.Label>
                <Input value={formState.login} onChange={event => setFormState('login', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['login']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.secret_key')}</Form.Label>
                <Input value={formState.password} type="password" onChange={event => setFormState('password', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['password']) || ['']]} />
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.playpass_server')}</Form.Label>
                <Select useNew value={formState.getin_url} onChange={(_, { value }) => setFormState('getin_url', value)} options={PlaypassForm.options} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['getin_url']) || ['']]} />
        </>
    );
}

PlaypassForm.options = [
    {
        text: 'Production',
        value: 'https://getin.playpass.eu'
    },
    {
        text: 'Demo',
        value: 'https://getin.demo.playpass.eu'
    },
    {
        text: 'Edge',
        value: 'https://getin.edge.playpass.eu'
    }
];

export function VivenuForm({ formState, setFormState, formErrors }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label>{t('ticket.webservice.form.access_token')}</Form.Label>
                <Input value={formState.access_token} onChange={event => setFormState('access_token', event.target.value)} />
            </Form.Field>
            <Form.FieldErrors errors={[t(formErrors['access_token']) || ['']]} />
        </>
    );
}
